import React from 'react';
import cn from 'classname';
import moment from 'moment';
import _sumBy from 'lodash/sumBy';
import { connect } from 'react-redux';

const OrdinaryRow = ({
	row, intl, activeRowId, approve, decline, setActiveRow, remove,
	can, toggleCommentPopup
}) => (
	<tr
		className={cn({ 'row-done': row.status === 'done', 'row-declined': row.status === 'declined' })}
	>
		<td
			className={`id fixed-col ${cn({
				'col-done': row.status === 'done', 'col-declined': row.status === 'declined',
				'hover-pointer': true
			})}` }
		>
			<p>ID: <span>{row.id}</span></p>
			<p><span>{row.manager_email}</span></p>
			<p><span>{row.affiliate_name}</span></p>
			<p><span>{row.affiliate_id}</span></p>
			<p><span>{row.country_name}</span></p>
			<p><span>{row.offer_name}</span> </p>
			{row.campaign_id && <p><span>Campaign id: {row.campaign_id}</span> </p>}
		</td>
		<td className="garant_approve_request_cell">
			<p>Starts at:<span> {moment(row.starts_at).format('DD-MM-YYYY')}</span></p>
			<p>Ends at:<span> {moment(row.ends_at).format('DD-MM-YYYY')}</span></p>
		</td>
		<td className="garant_approve_request_cell">
			<span>{moment(row.created_at).format('DD-MM-YYYY')}</span>
		</td>
		<td className="garant_approve_request_cell">
			<span>{row.sid}</span>
		</td>
		<td className="garant_approve_request_cell">
			{ row.target_percent }
		</td>
		<td className="garant_approve_request_cell">
			{ 	row.status === 'awaiting'
				? row.toApproveCount
				: (row.approved_conversions && row.approved_conversions.length)
			}
		</td>
		<td className="garant_approve_request_cell">
			{ row.pending_count }
		</td>
		<td className="garant_approve_request_cell">
			{ Math.round(row.approve_after_increasing * 100) / 100 }
		</td>
		<td className="garant_approve_request_cell">
			{row.status === 'awaiting'
				? (_sumBy(row.rejectedToApproveData, i => Number(i.payout))
					+ _sumBy(row.trashToApproveData, i => Number(i.payout))
					+ _sumBy(row.pendingToApproveData, i => Number(i.payout)))
				: _sumBy(row.approved_conversions, i => Number(i.payout))
			}
			{` usd`}
		</td>
		<td>{row.status === 'awaiting' ? row.not_trash_count : '-'}</td>
		<td
			onClick={toggleCommentPopup.bind(null, row.comment, row.id)}
			className="hover-pointer"
		>
			{row.comment}
		</td>
		<td className={`garant_approve_request-offer_margin_hint interval-${row.usd_margin_interval || 14}`}>
			{Math.round(Number(row.usd_margin) * 100)/100}
		</td>
		<td>
			{
				row.garant_register_start_leads_setting
				&& row.garant_register_start_leads_setting
					.map((set, index) => <p key={index}>{set.start_duration} - {set.start_leads_count} leads</p>)
			}
			{
				!!row.garant_register_start &&
				<p>
					<span>Garant period: </span>
					{moment(row.garant_register_start).format('DD-MM-YY')}
					{` - `}
					{moment(row.garant_register_end).format('DD-MM-YY')}
				</p>
			}
			{
				!!row.garant_register_target_percent &&
				`${row.garant_register_target_percent} %`
			}

		</td>
		<td className={`fixed-col-right ${cn({
			'col-done': row.status === 'done', 'col-declined': row.status === 'declined'
		})}`}>
			{
				row.status === 'awaiting' &&
				<div className="approve-request-control-buttons-container">
					{can('confirm') &&
						<button className="approve-btn" onClick={approve.bind(null, row.id)} ></button>
					}
					{can('confirm') &&
						<button className="decline-btn" onClick={decline.bind(null, row.id)} ></button>
					}
					<button className="remove-btn" onClick={remove.bind(null, row.id)} >
					</button>
				</div>
			}
		</td>
	</tr>
);

export default connect(state => ({ requestTypes: state.root.lists['manual-approve-request-types'] }))(OrdinaryRow);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-garant-approve-requests/components/table/row.js